export default "__VITE_ASSET__79a3338b__"